import { Ref } from 'vue';
import { useCloudApi } from '@/components/Cloud/Hooks/useCloudApi.js';
import { CloudService } from '@/services/api/integration.service';
import { useRoute } from 'vue-router';
import { RdsGlobalFrequencyResponse } from '@/components/Cloud/Hooks/cloud.all.types';

interface RespType {
  isLoading: Ref<boolean>;
  data: Ref<unknown>;
  error: Ref<null>;
  makeAPICall: (params: any) => Promise<void>;
}

export function useFetchGlobalFrequency() {
  const { params } = useRoute();

  const { isLoading, data, error, makeAPICall }: RespType = useCloudApi(
    CloudService.getGlobalFrequency,
    (resp) => resp?.data,
  );

  const fetchGlobalFrequency = () => {
    makeAPICall({
      subscriptionId: params.subscriptionId,
    });
  };

  return {
    isLoading,
    data: data as Ref<RdsGlobalFrequencyResponse>,
    error,
    fetchGlobalFrequency,
  };
}
